import { NavLink } from "react-router-dom";
import { House, MagnifyingGlass, PlusCircle, ChatCircleDots, UserCircle, ShieldCheck } from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth";
import { roleHome } from "@/components/RoleGuard";

// A predictable, thumb-friendly navigation bar for the hosted iOS app and small screens.
export default function MobileTabBar() {
    const { user } = useAuth();
    const isAdmin = (user?.role === "admin" || user?.roles?.includes("admin"));
    const tabs = [
        { to: "/", label: "Inicio", Icon: House, match: (p) => p === "/" },
        { to: "/marketplace", label: "Explorar", Icon: MagnifyingGlass, match: (p) => p === "/marketplace" || p.startsWith("/producto/") },
        { to: "/publicar", label: "Publicar", Icon: PlusCircle, match: (p) => p === "/publicar" },
        { to: "/mensajes", label: "Mensajes", Icon: ChatCircleDots, match: (p) => p.startsWith("/mensajes") },
        { to: user ? roleHome(user.roles?.includes("admin") ? "admin" : user.role) : "/ingresar", label: isAdmin ? "Admin" : user ? "Mi cuenta" : "Ingresar", Icon: isAdmin ? ShieldCheck : UserCircle, match: (p) => /^(\/mi-cuenta|\/ingresar|\/registro|\/productor|\/comprador|\/transportista|\/admin|\/perfil)/.test(p) },
    ];
    return (
        <nav aria-label="Navegación inferior" data-testid="mobile-tab-bar"
            className="md:hidden fixed inset-x-0 bottom-0 z-50 border-t border-border bg-white/95 backdrop-blur-md shadow-[0_-6px_18px_rgba(0,0,0,0.06)]">
            <div className="grid grid-cols-5 max-w-xl mx-auto pb-[max(0.25rem,env(safe-area-inset-bottom))]">
                {tabs.map(({ to, label, Icon }) => (
                    <NavLink key={label} to={to} aria-label={label}
                        className={({ isActive }) => "min-h-[56px] py-2 flex flex-col gap-0.5 items-center justify-center text-[11px] font-semibold " +
                            (isActive ? "text-[#2E7D32]" : "text-muted-foreground")}>
                        {({ isActive }) => <><Icon size={22} weight={isActive ? "fill" : "regular"} aria-hidden="true" /><span>{label}</span></>}
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}
